import React from 'react'
import SvgWrapper from '../SvgWrapper'
import type { IllustrationProps } from './types'

const RelaxBookWomanIllustration: React.FC<IllustrationProps> = ({ width = 122, height = 160 }) => (
  <SvgWrapper height={height} width={width} viewBox="0 0 122 160" fill="none">
    <path d="M32.194 47.728V37.642h-1.568v10.086a2.09 2.09 0 1 0 1.568 0Z" fill="#CACDDA" />
    <path
      d="M35.854 149.521H25.137V19.344h-4.182V149.52H10.238a9.674 9.674 0 0 0-9.673 9.672h44.962a9.672 9.672 0 0 0-9.672-9.672Z"
      fill="#CACDDA"
    />
    <path
      d="M.587 38.687h44.917L42.757 4.355A4.757 4.757 0 0 0 38.04 0H8.05a4.757 4.757 0 0 0-4.716 4.355L.587 38.687Z"
      fill="#FF0080"
    />
    <path
      d="M63.129 98.945a3.235 3.235 0 0 0-3.727 2.703l-1.265 8.299 4.303 1.141 3.152-7.732a3.237 3.237 0 0 0-1.133-3.866 3.233 3.233 0 0 0-1.33-.545Z"
      fill="#FFB9B9"
    />
    <path
      d="M63.048 109.932c2.388 9.489 1.36 18.168-7.531 24.983-10.665-2.94-17.758-10.032-22.087-20.342a5.141 5.141 0 0 1 1.213-5.733 5.147 5.147 0 0 1 4.813-1.24 5.14 5.14 0 0 1 2.603 1.612l10.465 12.079 4.909-12.179 5.615.82Z"
      fill="#A5A9DA"
    />
    <path
      d="M117.691 159.718c-9.738-.518-15.787-3.861-17.252-10.718l1.568-2.875 17.957 8.18a2.514 2.514 0 0 1 1.469 2.381 2.513 2.513 0 0 1-1.646 2.263l-2.096.769Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M110.167 159.786c-5.06-.153-9.925-.105-14.536.207a3.082 3.082 0 0 1-3.28-2.827l-.276-3.461-3.921-6.273 3.398-3.399c5.71 5.688 11.974 10.466 19.412 13.306a1.348 1.348 0 0 1 .518 1.522 1.346 1.346 0 0 1-1.315.925Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M82.664 135.146c-6.461 11.56-12.815 19.354-21.175 23.526-10.282 3.394-17.799-1.103-23.657-10.325l16.994-11.241 2.483 2.484 22.506-17.127a2.876 2.876 0 0 1 4.043.09l19.197 23.572-2.353 3.921-18.038-14.9Z"
      fill="#2E35A8"
    />
    <path opacity=".798" d="m88.415 148.739-8.888-13.593 2.091-3.921 11.763 12.286-4.966 5.228Z" fill="#2E35A8" />
    <path
      d="m39.532 112.927-9.932-3.399a12.336 12.336 0 0 0 1.83-7.842h8.103c-.462 3.989-.53 7.772 0 11.241Z"
      fill="#FFB9B9"
    />
    <path
      d="M57.535 140.06c-6.806 3.257-13.844 5.821-18.787 10.508-11.552-7.844-22.26-32.209-8.365-42.869 4.742 2.775 8.98 4.761 8.888 0l18.264 32.361Z"
      fill="#A5A9DA"
    />
    <path d="m55.085 114.606 8.134 9.562 12.201-14.399-8.244-10.003-12.091 14.84Z" fill="#020537" fillOpacity=".87" />
    <path
      d="m73.332 110.099-9.673-7.915c.55-1.319 3.188-.879 3.188-.879l7.572 7.676c.263.268.49.57.672.899l-1.759.219Z"
      fill="#CACDDA"
    />
    <path
      d="m73.77 109.549-10.991-8.574-12.201 18.468 11.488 7.748c1.098.44 2.199-.33 2.199-.33l11.212-17.147-1.706-.165Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="m65.77 101.196-.073.081 8.697 7.983.075-.081-8.698-7.983ZM65.046 101.265l-.072.082 9.09 8.025.073-.082-9.09-8.025ZM64.477 101.424l-.07.085 9.435 7.862.07-.084-9.435-7.863Z"
      fill="#CACDDA"
    />
    <path
      d="M59.476 117.413a3.226 3.226 0 0 0-2.44-.524 3.222 3.222 0 0 0-2.086 1.368l-4.7 6.956 3.398 2.875 6.163-5.634a3.23 3.23 0 0 0-.335-5.041Z"
      fill="#FFB9B9"
    />
    <path
      d="M54.694 127.304c-1.91 9.597-6.56 16.998-17.514 19.344-8.375-7.228-11.744-16.677-11.235-27.846a5.145 5.145 0 0 1 10.095-1.145l4.277 15.398 9.655-8.898 4.722 3.147Z"
      fill="#A5A9DA"
    />
    <path d="M36.218 105.474a9.064 9.064 0 1 0 1.268-18.084 9.064 9.064 0 0 0-1.268 18.084Z" fill="#FFB9B9" />
    <path
      d="M22.904 92.21a8.018 8.018 0 1 0 1.122-15.998 8.018 8.018 0 0 0-1.122 15.998Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M16.102 90.35a8.02 8.02 0 0 0 12.644-3.333 8.019 8.019 0 1 1-15.373-4.374 8.016 8.016 0 0 0 2.729 7.708Z"
      fill="#020537"
      fillOpacity=".87"
    />
    <path
      d="M47.668 92.572c-1.221-2.597-1.682-3.678-3.376-5.327-1.498-1.456-3.428-1.988-5.098-.825A9.539 9.539 0 0 0 26.734 100a9.536 9.536 0 0 0 17.569-5.57c1.387-.095 1.978-1.76 3.365-1.859Z"
      fill="#020537"
      fillOpacity=".87"
    />
  </SvgWrapper>
)

export default RelaxBookWomanIllustration
